/**
 * UserGradeListContainer
 * --
 */
import React, { useState, useMemo } from 'react';
import dayjs from 'dayjs';
import { useGetUsers } from 'hooks/UserHooks';
import { useGetGrades } from 'hooks/GradeHooks';
import { useGetMemberShipGrades } from 'hooks/MemberShipGradeHooks';
import UserGradeListPresenter from './UserGradeListPresenter';

/**----------------------------------------
 * [Component] 총관리자: 회원관리 -> 등급변동내역
 * ----------------------------------------
 */
const UserGradeListContainer = ({ permission }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);

  const [currentShop, setCurrentShop] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [period, setPeriod] = useState({
    start_date: dayjs().subtract(1, 'months').startOf('day').unix(),
    end_date: dayjs().endOf('day').unix(),
  });
  const [inputValue, setInputValue] = React.useState({
    point: 0,
    expired_date: 0,
    memo: null,
  });

  /* ===== MUTATE ===== */

  const { data: UserList } = useGetUsers(
    { filter: 'user_name' },
    {
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) {
          return [];
        }

        return data;
      },
      initialData: [],
    }
  );
  const { data: GradeList } = useGetGrades(null, {
    select: (res) => {
      const { status, data } = res;
      if (status !== 200) return [];

      return data;
    },
    initialData: [],
  });
  const { data: MemerShipGrade, refetch: refetchMemberShipGrade } =
    useGetMemberShipGrades(
      { start_date: period.start_date, end_date: period.end_date },
      {
        select: (res) => {
          const { status, data } = res;

          if (status !== 200) {
            return [];
          }

          return data;
        },
        initialData: [],
      }
    );

  const userMemberShipList = useMemo(() => {
    const userList = UserList?.map((user) => {
      // console.log(user);
      const matchedGrade = GradeList?.find(
        (grade) => grade?.grade_id === user?.grade_id
      );
      const userMemberShipGrade = MemerShipGrade?.filter(
        (memberShip) => memberShip.user_id === user.user_id
      ).map((memberShip) => {
        const matchedGrade = GradeList?.find(
          (grade) => grade?.grade_id === memberShip?.grade_id
        );
        return {
          key: memberShip?.membership_grade_id,
          ...matchedGrade,
          ...memberShip,
        };
      });

      return {
        key: user?.user_id,
        ...matchedGrade,
        ...user,
        membership_grade: userMemberShipGrade,
      };
    });
    return userList;
  }, [GradeList, MemerShipGrade, UserList]);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <UserGradeListPresenter
      {...{
        /* States */
        userMemberShipList: userMemberShipList,
        userList: UserList,
        gradeList: GradeList,
        MemerShipGrade: MemerShipGrade,
        permission,
        loading,
        currentUser,
        setCurrentUser,
        period,
        setPeriod,
        currentShop,
        inputValue: inputValue,
        setInputValue: setInputValue,
        /* Events */
        setCurrentShop,
        setLoading,
      }}
    />
  );
};

/* DF */
UserGradeListContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default UserGradeListContainer;
